import dayjs from 'dayjs';
import { monitoredReplace } from 'src/utils/sentry/navigation';

export const formatPhoneNumber = (phoneNumber: string) => {
    return  '+82' + phoneNumber.slice(1, phoneNumber.length)
}
export const guid = (): string => {
    function _p8 (s: any) {
      const p = (Math.random().toString(16) + '000000000').substr(2, 8)
      return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p
    }
    return _p8(false) + _p8(true) + _p8(true) + _p8(false)
  }
export const forwardPlaystore = () => {
  monitoredReplace("https://play.google.com/store/apps/details?id=kr.co.datau.mfinder", 'forward-playstore');
  setTimeout(closeWithFallback, 3000)

}

export const closeWithFallback = () => {
  if (window.opener) {
    try {
      window.close()
      return
    } catch {}
  }

  if (window.history.length > 1) {
    window.history.back()
    return
  }

  window.location.replace('about:blank')
}

/**
 * 시스템 점검 시간에 해당하는 경우 알림창을 띄우는 함수
 *
 * @returns boolean
 */

export const showMaintenanceAlert = (): boolean => {
  const now = dayjs();
  const sd = dayjs("2025-04-22 00:30:00")
  const ed = dayjs("2025-04-22 04:00:00")

  const isDuringMaintenance = now.isAfter(sd) && now.isBefore(ed);

  if (isDuringMaintenance) {
    alert(
      '[시스템 점검 안내]\n\n' +
        '시스템 점검 중 입니다.\n\n' +
        '⦁ 점검 기간 : 2025년 4월 22일(화) 01:00 ~ 04:00 (3H 예정)\n' +
        '※ 점검은 예정된 시간보다 단축 또는 연장될 수 있습니다.\n\n' +
        '서비스 이용에 불편을 드려 대단히 죄송합니다.',
    );
    return true;
  }

  return false;
};
